module.exports = __webpack_public_path__ + "static/img/meeting-arrangement.7c23f051.jpg";